import { render, staticRenderFns } from "./EventiDizionariComponent.vue?vue&type=template&id=72237675"
import script from "./EventiDizionariComponent.vue?vue&type=script&lang=js"
export * from "./EventiDizionariComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports